import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";
import { ICollaboratorCost } from "../../models/collaborator-costs";
import { CollaboratorsService } from "../../collaborators.service";

@Component({
  selector: "app-collaborators-costs",
  templateUrl: "./collaborators-costs.component.html",
  styleUrls: ["./collaborators-costs.component.scss"],
})
export class CollaboratorsCostsComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public collaboratorList: ICollaboratorCost[] = [];
  public filterCollaboratorList: ICollaboratorCost[] = [];
  public selectedCollaborator: ICollaboratorCost[] = null;
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: string[] = [];
  public selectedYear: string = moment().format("YYYY");
  public selectedMonth: string = moment().format("M");

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: false,
            link: "/",
          },
          {
            name: "MENU.USERS",
            isLink: false,
          },
          {
            name: "TITLES.USERS_TYPES.collaborator",
            isLink: false,
          },
          {
            name: "COSTS",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    for (let i: number = 2023; i <= Number(this.selectedYear); i++) {
      this.availableYears.push(String(i));
    }
    if (!this._authenticationService.hasCapability("show_menu_collaborator_costs")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadCollaborators();
    this._utilService.hideLoading();
  }

  async loadCollaborators() {
    if (Number(this.selectedMonth) > Number(moment().format("M")) && Number(this.selectedYear) >= Number(moment().year())) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_VIEW_FUTURE_COST" });

      this.selectedMonth = moment().format("M");
      this.selectedYear = moment().format("YYYY");
      this._changeDetectorRef.detectChanges();
      return false;
    }
    this.collaboratorList = await this._collaboratorService.getCollaboratorsCostList(this.selectedMonth, this.selectedYear);
    this.search();
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  search() {
    let filteredArray: ICollaboratorCost[] = this.collaboratorList;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter((collaborator: ICollaboratorCost) => collaborator.complete_name.toLowerCase().includes(key));
    }
    this.filterCollaboratorList = filteredArray;
  }

  formatLabel(month: number) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }

  formatPrice(cost: ICollaboratorCost) {
    cost.new_monthly_cost = this._utilService.addDotsToNumber(cost.new_monthly_cost);
  }

  openEdit(cost: ICollaboratorCost) {
    cost.editCost = true;
    cost.new_monthly_cost = this._utilService.addDotsToNumber(cost.monthly_cost);
  }

  cancelEdit(cost: ICollaboratorCost) {
    cost.editCost = false;
    cost.new_monthly_cost = null;
  }

  async updateCost(cost: ICollaboratorCost) {
    this._utilService.showLoading();
    if (!this._authenticationService.hasCapability("manage_collaborators_costs")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!cost.new_monthly_cost) {
      this._utilService.hideLoading();
      this._utilService.showSWALError({ text: "ERROR_INSERT_COST" });
      return false;
    }

    let data: { monthly_cost: string } = {
      monthly_cost: cost.new_monthly_cost,
    };
    this._collaboratorService
      .updateCostCollaborator(cost.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this.loadCollaborators();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_COLLABORATOR_COST" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_UPDATE_COLLABORATOR_COST" });
      });
  }
}
